import apiWrapper from '../apiWrapprer'

const endpoints = {
  getAccountDataRetention: '/frontend/webMethods/Statistics.asmx/GetAccountDataRetention'
}

export const getAccountDataRetention = (idList, guid) => {
  const url = endpoints.getAccountDataRetention
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid
    })
  }).then(extractData)
}

const extractData = ({ data }) => JSON.parse(data.d)

export const isFrontendError = (result) => {
  return (result.$types && Object.keys(result.$types)[0].split(',').map(k => k.trim()).includes('mailUp.lib.FrontendException')) ||
  (result.$type && (result.$type.match(/mailUp\.lib\.FrontendException/) !== null))
}
